"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TriangleRight = void 0;
var react_1 = __importDefault(require("react"));
var TriangleRight = function (_a) {
  var className = _a.className;
  return react_1.default.createElement("svg", {
    className: className,
    width: "16",
    height: "12",
    viewBox: "0 0 16 12"
  }, react_1.default.createElement("path", {
    d: "M11.0094 5.0452L6.2614 0.297214C5.99391 0.0297213 5.59267 -0.104025 5.19144 0.0965944C4.7902 0.230341 4.52271 0.631579 4.52271 1.03282V10.9969C4.52271 11.3981 4.7902 11.7994 5.19144 11.9331C5.32518 12 5.45893 12 5.59267 12C5.86017 12 6.12766 11.8663 6.32828 11.6656L11.0763 6.91765C11.3438 6.65015 11.4775 6.31579 11.4775 5.91455C11.4775 5.51331 11.2769 5.31269 11.0094 5.0452Z"
  }));
};
exports.TriangleRight = TriangleRight;